import { render, staticRenderFns } from "./WardrobePreview.vue?vue&type=template&id=2fd85225&"
import script from "./WardrobePreview.vue?vue&type=script&lang=js&"
export * from "./WardrobePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports